export default __webpack_public_path__ + "media/zurb/img/work/client-logo-medium-590ac0e2a0a78c6ff8d2aa03ddb261e4.jpg";